import React, { useMemo } from 'react';
import { useTranslation } from 'utils/i18n';
import LegalLayout from 'components/legal/LegalLayout';
import { mapTermsOfServiceToSections } from 'utils/legal/sections';

const TermsOfService = () => {
  const { t, language } = useTranslation();
  
  // Re-compute sections when language changes
  const sections = useMemo(() => mapTermsOfServiceToSections(t), [language]);
  const title = t('title', 'terms') || 'Terms of Service';
  const lastUpdated = t('lastUpdated', 'terms') || '';

  return <LegalLayout title={title} lastUpdated={lastUpdated} sections={sections} />;
};

export default TermsOfService;
